// Whose meeting it is, in the meeting's own words (CR-20261009-001 L3.1, g-canvas-words). Helix stamps a meeting the RM
// hosts with `hostTitle` and `brand` (migration 0022; context/20 §1); a meeting without them — every meeting made
// before 0022, and every one Helix makes while CLIKHOME_RM_HOSTS_CANVAS is off — keeps today's words, byte for byte.
// The words come from the meeting's record, never from a switch: a meeting booked before the flip reads as it did.
//
// tests/unit/rm-host.test.mjs allows "Sales manager", "Mana Skanda" and "The Right Life" in src/app only between the
// two LEGACY markers below (and in product.js / admin.js): a new customer-facing literal fails it.

// LEGACY-BEGIN — today's words
const LEGACY = {
  eyebrow: "Your Walkin meeting · The Right Life",
  hostLabel: "Sales manager",
  hostLine: (host) => `Your sales manager: ${host}`,
  assistNote: (first) => `What is said here is written down as you talk, so ${first} can answer you well and nothing is lost afterwards. It stays with Mana Skanda and Clikin.ai.`,
  priceLine: (first) => `. ${first} sends it from Mana's sheet — the prices are Mana's, for the exact unit and floor.`,
  hostFallback: "The sales manager",
  briefRows: (rows) => rows,
};
// LEGACY-END

// The viewer of an RM-hosted meeting's navigator IS the RM: the brief's rows about the RM say nothing to him.
const NOT_FOR_THE_RM = new Set(["RM", "Asked RM"]);

export function meetingWords(meeting) {
  const m = meeting || {};
  const title = typeof m.hostTitle === "string" && m.hostTitle.trim() ? m.hostTitle.trim() : "";
  const words = m.brand ? {
    eyebrow: "Your Walkin meeting · Clikin.ai",
    hostLabel: "Your Clikin.ai relationship manager",
    hostLine: LEGACY.hostLine,
    assistNote: (first) => `What is said here is written down as you talk, so ${first} can answer you well and nothing is lost afterwards. It stays with Clikin.ai.`,
    priceLine: (first) => `. ${first} sends it on WhatsApp — the prices are the builder's, for the exact unit and floor.`,
    hostFallback: "The RM",
    briefRows: (rows) => rows.filter(([k]) => !NOT_FOR_THE_RM.has(k)),
  } : LEGACY;
  return title ? { ...words, hostLine: (host) => `${title}: ${host}` } : words;
}

// CR-20261009-001 L3.3 (US-3.3.3, D555 A): an RM-hosted plain call with live assist tells her, before she joins, that
// what is said is written down — in ClikHome's words (L4 owns the sentence). Only on a branded meeting and never on
// the host's own page: a NULL meeting's join page is today's, byte for byte (a plain call had no assist).
export function plainCallAssistNote(meeting, isHost) {
  if (isHost || !meeting?.assist || !meeting?.brand) return null;
  const words = meetingWords(meeting);
  const first = String(meeting.hostName || "").trim().split(/\s+/)[0] || words.hostFallback;
  return words.assistNote(first);
}
